var map = {
	"./baanbeheer.svg": 13,
	"./baanexploitatie.svg": 14,
	"./bestuur.svg": 15,
	"./caddie.svg": 16,
	"./chevron.svg": 17,
	"./close.svg": 18,
	"./download.svg": 19,
	"./email.svg": 20,
	"./facebook.svg": 21,
	"./filter.svg": 22,
	"./golf.svg": 23,
	"./golfacademie.svg": 24,
	"./golfnl.svg": 25,
	"./golfregels.svg": 26,
	"./handicapping.svg": 27,
	"./heart.svg": 28,
	"./informatieplein.svg": 29,
	"./information.svg": 30,
	"./instagram.svg": 31,
	"./ledenwerving.svg": 32,
	"./linkedin.svg": 33,
	"./menu.svg": 34,
	"./onderzoek.svg": 35,
	"./pdf.svg": 36,
	"./phone.svg": 37,
	"./raak.svg": 38,
	"./sportief_beleid.svg": 39,
	"./twitter.svg": 40,
	"./video.svg": 41,
	"./x.svg": 42,
	"./youtube.svg": 43,
	"./zoeken.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;